import { registerArchetype } from './index.js';
import { livingEnemies, enemySide, getRuntimes, lowestHpEnemy } from '../combat.js';
registerArchetype({
    id: 'mark',
    apply: ({ state, source, params }) => {
        const duration = params.duration ?? 5;
        const bonusPct = params.bonusPct ?? 0.25;
        const enemies = livingEnemies(state, source.side);
        if (enemies.length === 0)
            return;
        const target = lowestHpEnemy(state, source.side);
        const enemyKey = enemySide(source.side);
        getRuntimes(state, enemyKey)[target.slot].statuses.push({
            id: `mark_${state.tick}_${target.slot}`,
            kind: 'mark',
            remainingTicks: duration,
            params: { bonusPct }
        });
        state.events.push({ t: state.tick, kind: 'status_apply', side: enemyKey, slot: target.slot, status: 'mark', duration });
    }
});
